import styled from 'styled-components'

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 515vh !important;
  width: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.6);
  @media screen and (max-width: 1024px) {
    height: 295vh !important;
  }
  @media screen and (max-width: 768px) {
    height: 400vh !important;
  }
  @media screen and (max-width: 361px) {
    height: 666vh !important;
  }
  @media screen and (max-width: 450px) {
    height: 501vh !important;
  }
  @media screen and (min-width: 480px) {
    height: 500vh;
  }
`

export const Modal = styled.div`
  width: 300px;
  height: 200px;
  position: fixed;
  top: 40%;
  left: 50%;
  margin-top: -100px;
  margin-left: -150px;
  text-align: center;
  z-index: 11;
`
export const Container = styled.div`
  margin-top: 80px;
  text-align: center;
  color: #fff;
`

export const Loader = styled.div`
   {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    position: absolute;
    left: 40%;
  }

  div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 40px 40px;
  }

  div:after {
    content: ' ';
    display: block;
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #fff;
    margin: -4px 0 0 -4px;
  }

  div:nth-child(1) {
    animation-delay: -0.036s;
  }

  div:nth-child(1):after {
    top: 63px;
    left: 63px;
  }

  div:nth-child(2) {
    animation-delay: -0.072s;
  }

  div:nth-child(2):after {
    top: 68px;
    left: 56px;
  }

  div:nth-child(3) {
    animation-delay: -0.108s;
  }

  div:nth-child(3):after {
    top: 71px;
    left: 48px;
  }

  div:nth-child(4) {
    animation-delay: -0.144s;
  }

  div:nth-child(4):after {
    top: 72px;
    left: 40px;
  }

  div:nth-child(5) {
    animation-delay: -0.18s;
  }

  div:nth-child(5):after {
    top: 71px;
    left: 32px;
  }

  div:nth-child(6) {
    animation-delay: -0.216s;
  }

  div:nth-child(6):after {
    top: 68px;
    left: 24px;
  }

  div:nth-child(7) {
    animation-delay: -0.252s;
  }

  div:nth-child(7):after {
    top: 63px;
    left: 17px;
  }

  div:nth-child(8) {
    animation-delay: -0.288s;
  }

  div:nth-child(8):after {
    top: 56px;
    left: 12px;
  }

  @keyframes lds-roller {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
